export type AccessMessageKind = "expired" | "denied" | "success";

interface Props {
  kind: AccessMessageKind;
}

const COPY: Record<
  AccessMessageKind,
  { title: string; body: string; icon: string }
> = {
  expired: {
    title: "Sesión caducada",
    body: "Vuelve a introducir tu correo para acceder a tu edición.",
    icon: "!",
  },
  denied: {
    title: "Email no permitido",
    body: "Este correo no tiene acceso. Usa tu email corporativo de Iberdrola.",
    icon: "×",
  },
  success: {
    title: "Acceso OK",
    body: "Redirigiendo a tu edición…",
    icon: "✓",
  },
};

export default function AccessMessage({ kind }: Props) {
  const content = COPY[kind];

  return (
    <div
      className={`access-message access-message--${kind}`}
      role={kind === "success" ? "status" : "alert"}
    >
      <span className="access-message__icon" aria-hidden>
        {content.icon}
      </span>
      <div className="access-message__copy">
        <p className="access-message__title">{content.title}</p>
        <p className="access-message__body">{content.body}</p>
      </div>
    </div>
  );
}
